import React from 'react';
import { Spin } from 'antd';
import type { SpinProps } from 'antd';

export type AppSpinProps = SpinProps;

const AppSpin: React.FC<AppSpinProps> = props => {
  return <Spin {...props} />;
};

export default AppSpin;
